import React from 'react';
import BaseComponent from 'components/BaseComponent';
import { Modal, Form, Input, TimePicker  } from 'antd';
import { contentRsg,materialConRsg } from '@/utils/common/constants';
import { TransitmodeComb } from 'components/Playlist';
import moment from 'moment';
import 'components/Modal/modal.less';
import 'components/Playlist/style/mediaArea.less';
import 'components/Modal/style/modalMedia.less';
const FormItem = Form.Item;

/* 重命名组件  */
@Form.create()
export class RenameComponent extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            checkTransitMode: this.props.checkObj.transit_mode ?  parseInt(this.props.checkObj.transit_mode) : -1,
        }
    }

    componentWillReceiveProps(nextProps) {
        
    }

    /* 检查名称 */
    checkName = (row, value, callback) =>{
        const name_max = 40;
        if(value.trim().length > name_max) {
            callback(`${window.language['material.maxLength']}${name_max}`);
        }
        if(value.trim().length === 0){
            callback("名称不能为空");
        }
        var reg = new RegExp(materialConRsg);
        if(reg.test(value.trim())){
            callback(`文件名不能包含以下任何字符: \\ / : * ? " < > |`);            
        }
        callback();
    }

    onEdit = (param1, param2, key, filetype) => {
        let checkTransitMode = this.state.checkTransitMode;
        if (checkTransitMode !== key) {
            this.setState({
                checkTransitMode: key
            });
        }
    }

    render() {
        const { visible, type, checkObj, hideRenameHandler, renameHandler, form } = this.props;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 17 },
        };
        let checkTransitMode = this.state.checkTransitMode;
        if (!checkObj || !checkObj.name) {
            return null;
        }
        let name =  checkObj.name;
        let timeNode = null;
        let tmNode = null;
        let transitmodeProps = {
            size: 'small',
            value: checkTransitMode, 
            selected: '', 
            filetype: type, 
            rightMode: true,
            onEdit: this.onEdit,
        }
        if (type === '15' || type === '16' || type === '17' || type === '35') {
            timeNode = (
                <FormItem {...formItemLayout} label={window.language["playlist.duration"]}>
                    {getFieldDecorator('interval_time', {
                        rules: [{ 
                            required: true, 
                            message: window.language['material.timeIsNull'] 
                        }],
                        initialValue: moment(checkObj.interval_time, 'HH:mm:ss') || '',
                    })(
                        <TimePicker style={{width: '100%'}}/>
                    )}
                </FormItem>
            )
            tmNode = (
                <FormItem {...formItemLayout} label={window.language["playlist.transition.model"]}>
                    {getFieldDecorator('transit_mode', {
                        rules: [{ required: true }],
                        initialValue: checkTransitMode,
                    })(
                        <div className="material-office-transitmode">
                            <TransitmodeComb {...transitmodeProps} />
                        </div>
                    )}
                </FormItem>
            );
        }

        return (
            visible && 
            <Modal
            title={window.language['common.update']}
            visible={visible}
            width={550}
            maskClosable={false}
            onCancel={hideRenameHandler}
            onOk={renameHandler}
            className="material-rename-model show-modal-head material-model-style"
            >
                <div className="material-all-body">
                    <Form layout="horizontal">
                        <FormItem {...formItemLayout} className="material-form-top" label={window.language['material.columns.name']}>
                            {getFieldDecorator('name', {
                                initialValue: name,
                                rules: [{ 
                                    required: true, 
                                    message: window.language['material.pleaseEnterName'],
                                },
                                // {
                                //     pattern: contentRsg,
                                //     message: window.language['material.notSpecialChar']
                                // }, 
                                {
                                    validator: this.checkName
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        {timeNode}
                        {tmNode}
                    </Form>
                </div>
            </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/renameComponent.js